module.exports = __webpack_public_path__ + "img/map_Z3.5.B.02.3c07d690.svg";